module.exports = __webpack_public_path__ + "static/home/img/6.f1320b91.png";